import { useCallback } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { useCommon } from '../contexts/CommonContext';
import { trackEvent } from '../api/Billing/Tracking';
import { MetricStatus } from '../shared/BillingMetrics';
import { action, origin } from '../shared/SegmentEvents';

export interface TrackingEventData {
  knowledgeName?: string;
  knowcontName?: string;
  knowcontType?: string;
  knowcontSize?: number;
  knowcontPreProcessingOptions?: {
    optimization?: boolean;
    indexing?: boolean;
    contextualization?: boolean;
  };
  knowcontVersion?: string;
}

export const useKnowledgeBaseTracking = (): {
  trackKnowledgeBaseEvent: (eventType: string, additionalData?: TrackingEventData) => void;
} => {
  const { tenant } = useTenant();
  const {
    common: { loggedUser },
  } = useCommon();

  const trackKnowledgeBaseEvent = useCallback(
    (eventType: string, additionalData?: TrackingEventData) => {
      trackEvent(eventType, tenant, loggedUser, {
        date: new Date(),
        planStatus: MetricStatus.normal,
        action: action.CLICK,
        origin: origin.KNOWLEDGEBASE,
        ...additionalData,
      });
    },
    [tenant, loggedUser],
  );

  return {
    trackKnowledgeBaseEvent,
  };
};
